import { render, staticRenderFns } from "./GroupButton.vue?vue&type=template&id=55ed4403&scoped=true&"
import script from "./GroupButton.vue?vue&type=script&lang=js&"
export * from "./GroupButton.vue?vue&type=script&lang=js&"
import style0 from "./GroupButton.vue?vue&type=style&index=0&id=55ed4403&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ed4403",
  null
  
)

export default component.exports